import type { CodyChangeResult, CodyQuestion } from '$/dto/CodyChangeResult.dto.ts';
import type { CodyChange } from '$/requests/CodyChangeRequest.ts';

export type CodyReply =
  | { kind: 'question'; question: CodyQuestion; ask: string }
  | { kind: 'message'; message: string; canDo: boolean };

export const toCodyReply = (result: CodyChangeResult): CodyReply | null => {
  if (result.outcome === 'question') return { kind: 'question', question: result.question, ask: result.ask };
  if (result.outcome === 'not_changed') return { kind: 'message', message: result.message, canDo: result.can_do };

  return null;
};

export const toAnswerAsk = (
  reply: Extract<CodyReply, { kind: 'question' }>,
  option: { label: string; change: CodyChange }
): { label: string; change: CodyChange; ask: string } => ({ label: reply.ask, change: option.change, ask: reply.ask });
